<template>
  <div class="sign">
    <div class="sign-search">
        <div class="btn-box">
            <van-field size="small" v-model="search.productCode" placeholder="SKU" right-icon="scan" @focus="skuFocus" @blur="skuBlur" @keyup.13="toSearch" @click-right-icon="scan('productCode')"/>
            
            <van-field size="small" v-model="search.locationCode" placeholder="库位" @focus="locationFocus" @input="locationChange" @keyup.13="toSearch" right-icon="scan" @click-right-icon="scan('locationCode')"/>
        </div>

        <div class="toSearch-box">
            <button class="sign-toSearch" @click="toSearch">查询</button>
        </div>

    </div>

    <div class="stock-count">
        库存查询结果如下：
        <p>
            <span style="margin-right:10%;">总良品库存：{{total.goodProductTotal || 0}}</span> <span>总不良品库存：{{total.defectiveProductTotal || 0}}</span>
        </p>
    </div>

    <div class="sign-item">
			<template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
			</template>
			<template v-else>
        <template v-if="list.length">
            <ul>
              <li v-for="(item,index) in list" :key="index">
                <p style="margin-bottom:0;">批次号：{{item.batchCode}}</p>
                <div class="sign-item-left">
                  <p>SKU：<span style="color:#3399cc;">{{item.sku}}</span></p>
                  <p v-if="item.type === 0"><strong>良品</strong>箱数：{{item.containerNumber}}</p>
                  <p v-else><strong>不良品</strong>箱数：{{item.containerNumber}}</p>
                </div>
                <div class="sign-item-right">
                  <p>库位：<span style="color:#3399cc;">{{item.locationCode}}</span></p>
                  <p v-if="item.type === 0">良品库存：{{item.inventory}}</p>
                  <p v-else>不良品库存：{{item.inventory}}</p>
                </div>
              </li>
            </ul>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
			</template>
    </div>

		<van-popup v-model="showPicker" round position="bottom" :overlay="false">
			<van-picker
				show-toolbar
				confirm-button-text="选择"
				cancel-button-text="结束选择"
				:columns="columns"
				@cancel="onCancel"
				@confirm="onConfirm"
        :loading="loading"
        value-key="text"
        :item-height="30"
        :visible-item-count="5"
			/>
		</van-popup>
  </div>
</template>

<script>
import { Icon, Badge, Picker,Popup,Field,cell,Empty,Toast,Loading } from 'vant';
import { getInventoryBatchList, getInventoryBatchtotal,getWarehouseLocation } from '@/api/mobile/stock_api';
import { mapState } from 'vuex'
import { splitStr } from '/util/util'
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      showPicker: false,
      value: '',
      columns: [],
      submitData:{},
      warehouseList:[],
      
      list: [],
      search: {
        page: 1,
        pageSize: 9999,
        warehouseId: '', 
        locationCode: '',
        productCode: '',
      },
      total:{},
      loading: false,
      startSearch: false,
      focusType: ''
    }
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [cell.name]: cell,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field
  },
  mixins: [mixins],
  computed: {
    ...mapState({ warehouse: state => state.common.warehouse })
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      const that = this
      const user = window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
      const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
      this.$set(this.search,'warehouseId',_warehouse.warehouseId)

      this.viewportHeight = window.innerHeight
			window.addEventListener('resize',function(){
				if(that.viewportHeight - this.innerHeight > 50){ // 键盘弹起
					if(that.focusType === 'locationCode'){
            that.showPicker = false
					}
				}else{ // 键盘收起
					if(that.focusType === 'locationCode'){
            that.showPicker = true
					}
				}
			},true)
    },

    onConfirm(val){
      if(this.search.locationCode.includes(',')){
        const arr = this.search.locationCode.split(',')
        let saveArr = []
        let flag = false
        arr.forEach((item,i)=>{
          if(item != val.text){
            saveArr.push(item)
          }else{
            flag = true
          }
        })
        if(!flag){
          saveArr.push(val.text)
        }
			  this.$set(this.search, 'locationCode', saveArr.join())
      }else{
        if(this.search.locationCode === val.text){
			    this.$set(this.search, 'locationCode', '')
        }else{
          let flag = false
          this.columns.forEach((item)=>{
            if(item.text === this.search.locationCode){
              flag = true
            }
          })
          if(flag){
			      this.$set(this.search, 'locationCode', this.search.locationCode.concat(`,${val.text}`))
          }else{
			      this.$set(this.search, 'locationCode', val.text)
          }
        }
      }
    },

    onCancel(){
			this.showPicker = false;
      this.toSearch()
    },

    locationFocus(){
			this.focusType = 'locationCode'
			this.showPicker = true;
			this.$set(this.search, 'locationCode', '')
      this.locationChange()
    },

    locationChange(){
      const {locationCode,warehouseId} = this.search
      const data = {locationCode,warehouseId}

      if(!locationCode) return

      this.loading = true
      getWarehouseLocation(data).then(res=>{
        this.loading = false
        if(res.status === 200){
          const {response} = res
          this.warehouseList = response
          
          try{
            let arr = []
            response.forEach((item)=>{
              arr.push({text:item.locationCode,id:`${item.locationCode}_${parseInt(Math.random()*100000)}`});
            })
            this.columns = arr
          }catch{}
        }else{
          Toast.fail(res.msg);
        }
      })
    },

    skuBlur(){
      let {productCode} = this.search
      this.$set(this.search,'productCode',splitStr(productCode))
    },

    skuFocus(){
			this.focusType = 'productCode'
			this.showPicker = false;
    },

    scan(name){
      let that = this
      this.$wx.scanQRCode({
        needResult: 1,
        desc: 'scanQRCode desc',
        success: function (a) {
          that.$set(that.search,name,a.resultStr)
        }
      })
    },

    getList(){
      this.startSearch = true
      getInventoryBatchList(this.search).then(res=>{
        this.startSearch = false
				if (res.status === 200 && res.response) {
					const { pageData } = res.response

          if(!pageData.length) Toast('暂无匹配数据')

					this.list = pageData
				} else {
          this.list = []
					Toast.fail(res.msg);
				}
      })
    },

    getTotal(){
      const {warehouseId,locationCode,productCode} = this.search
      const data = {
        warehouseId,locationCode,productCode
      }

      getInventoryBatchtotal(data).then(res=>{
				if (res.status === 200) {
          const {response} = res
          this.total = response
				} else {
					Toast.fail(res.msg);
				}
      })
    },

    toSearch(){
      const { productCode, locationCode } = this.search
      if(!productCode && !locationCode){
        Toast('库位或SKU必填一个')
        return
      }
      this.getList()
      this.getTotal()
    },
  }
}
</script>

<style scoped>
    ::v-deep .van-cell{
        border: 1px solid #adadad;
        margin-bottom: 7px;
        padding: 5px 10px;
    }
    .sign{
      background-color: #fbf9fe;
    }
    .sign-search{
        box-sizing: border-box;
        width: 100%;
        padding: 10px 10px 3px 10px;
        display: flex;
    }
    .sign-search .btn-box{
        flex: .6;
    }
    .sign-search .toSearch-box{
        flex: .4;
        margin-left: 3%;
        min-height: 80px;
    }
    .sign-toSearch{
        width: 100%;
        height: 94%;
        min-height: 80px;
        background: linear-gradient(to right, #1d62f0 0%,#19d4fd 100%);
        border-radius: 5px;
        border: 0;
        color: #fff;
        font-size: 20px;
    }
    .toSearch-box{
      vertical-align: top;
    }
    .sign-item{
      border-top: 1px solid #ccc;
    }
    .sign-item li{
      border-bottom: 1px solid #ccc;
      background-color: #fbf9fe;
      padding: 1px 10px;
      font-size: 12px;
    }
    .sign-item-left{
      width: 50%;
      display: inline-block;
      box-sizing: border-box;
    }
    .sign-item-right{
      width: 50%;
      float: right;
      box-sizing: border-box;
    }
    .stock-count{
        font-size: 15px;
        padding: 0 10px;
    }
</style>